// Proof-of-Work primitives — pure functions

import { hash, concat, randomBytes } from './crypto.js';
import { NONCE_SIZE } from './constants.js';

/** Count leading zero bits in a single byte using lookup. */
const byteLeadingZeros = (byte: number): number =>
  byte === 0 ? 8
  : byte >= 128 ? 0
  : byte >= 64 ? 1
  : byte >= 32 ? 2
  : byte >= 16 ? 3
  : byte >= 8 ? 4
  : byte >= 4 ? 5
  : byte >= 2 ? 6
  : 7;

/** Count the number of leading zero bits in a hash. */
export const leadingZeros = (hashBytes: Uint8Array): number => {
  const firstNonZeroIndex = hashBytes.findIndex((b) => b !== 0);
  return firstNonZeroIndex === -1
    ? hashBytes.length * 8
    : firstNonZeroIndex * 8 + byteLeadingZeros(hashBytes[firstNonZeroIndex]);
};

/** Validate that a room tag has enough leading zero bits for PoW. */
export const validatePoW = (roomTag: Uint8Array, requiredBits: number): boolean =>
  leadingZeros(roomTag) >= requiredBits;

/**
 * Grind random 16-byte nonces until Hash(roomId || nonce || head)
 * has at least `powBits` leading zero bits.
 */
export const findValidNonce = (roomId: Uint8Array, head: Uint8Array, powBits: number): Uint8Array => {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const nonce = randomBytes(NONCE_SIZE);
    const tag = hash(concat(roomId, nonce, head));
    if (leadingZeros(tag) >= powBits) {
      return nonce;
    }
  }
};
